import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import HorizontalFileField from 'components/new_ui/Form/HorizontalFileField';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';

import SubmitButton from 'components/Widgets/SubmitButton';

import { useParams } from 'react-router-dom';
import useMember from 'components/Common/Managers/Hooks/useMember';
import Actions from './Actions';

import { useContext } from '../../Context';

export default function Form({ refresh }) {
  const formSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
  });

  const { memberId } = useParams();

  const member = useMember({ id: memberId });

  const { dispatch, actions } = useContext();

  const onSubmitHundler = (values, { setSubmitting, setErrors, resetForm }) => {
    Actions.create(
      memberId,
      values,
      () => {
        setSubmitting(false);
        resetForm();
        refresh();

        actions.load(dispatch);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        title: '',
        attachment: null,
        email: member?.attributes?.email,
        full_name: member?.attributes?.full_name,
      }}
      enableReinitialize
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col lg={6}>
              <HorizontalFileField
                name="attachment"
                fileTypes={['PDF', 'DOC', 'XDOC']}
                showPreview={false}
                disabled={isSubmitting}
              />
            </Col>

            <Col lg={6} className="d-flex flex-column">
              <HorizontalTextField name="title" label="Title" required />

              <HorizontalTextField name="email" label="Email" required disabled />
              <HorizontalTextField name="full_name" label="Name" required disabled />

              <div className="d-flex justify-content-end mt-auto mb-3">

                <SubmitButton loading={isSubmitting}>
                  Save
                </SubmitButton>
              </div>

            </Col>
          </Row>

        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  refresh: PropTypes.func.isRequired,
};
